// Configs de registres — traduites depuis le prototype app.js.
// Ajouter une entrée ici (+ la clé dans l'allowlist backend) crée un module CRUD complet.

const GENERIC_STATUS = ['Brouillon', 'Actif', 'À traiter', 'En cours', 'Validé', 'Archivé'];

// Gabarit de registre léger (équivalent de simpleRegistryConfig du prototype).
function simple(key, title, mainKey, mainLabel, mainOptions) {
  return {
    key, title,
    labelField: mainKey,
    dateField: 'date',
    columns: [mainKey, 'classId', 'studentName', 'staffName', 'date', 'status'],
    fields: [
      { key: mainKey, label: mainLabel, type: 'select', options: mainOptions, required: true },
      { key: 'schoolYear', label: 'Année scolaire', type: 'text' },
      { key: 'classId', label: 'Classe / niveau', type: 'ref', ref: 'classes' },
      { key: 'studentName', label: 'Élève', type: 'text' },
      { key: 'staffName', label: 'Responsable', type: 'text' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'status', label: 'Statut', type: 'select', options: GENERIC_STATUS },
      { key: 'description', label: 'Description', type: 'textarea' },
      { key: 'notes', label: 'Notes', type: 'textarea' },
    ],
  };
}

export const REGISTRIES = {
  // ── Lot 2 : registres légers (gabarit standard) ───────────
  admissions: {
    key: 'admissions',
    title: 'Admissions & réinscriptions',
    photo: true,
    labelField: 'lastName',
    columns: ['classId', 'lastName', 'firstNames', 'sexe', 'matricule', 'statut'],
    fields: [
      // Scolarité
      { key: 'classId', label: 'Classe', type: 'ref', ref: 'classes', required: true },
      { key: 'statut', label: 'Statut', type: 'select', required: true, options: ['Nouvelle inscription', 'Réinscription', 'Transfert entrant', 'Redoublant', 'Préinscription', 'Admis', "Liste d'attente"] },
      { key: 'matricule', label: 'Matricule', type: 'text' },
      // Identité
      { key: 'lastName', label: 'Noms', type: 'text', required: true },
      { key: 'firstNames', label: 'Prénoms', type: 'text', required: true },
      { key: 'sexe', label: 'Sexe', type: 'select', options: ['Masculin', 'Féminin'] },
      { key: 'birthPlace', label: 'Lieu de naissance', type: 'text' },
      { key: 'birthDay', label: 'Jour de naissance', type: 'number' },
      { key: 'birthMonth', label: 'Mois de naissance', type: 'number' },
      { key: 'birthYear', label: 'Année de naissance', type: 'number' },
      { key: 'age', label: 'Âge', type: 'number' },
      { key: 'anciennete', label: 'Ancienneté élève', type: 'select', options: ['Nouveau', 'Ancien'] },
      { key: 'motherTongue', label: 'Langue maternelle', type: 'text' },
      // Scolarité antérieure
      { key: 'originSchool', label: "Établissement d'origine", type: 'text' },
      { key: 'lastClass', label: 'Dernière classe fréquentée', type: 'text' },
      { key: 'lastYear', label: 'Dernière année fréquentée', type: 'text' },
      { key: 'redoubled', label: 'Classe redoublée', type: 'select', options: ['Oui', 'Non'] },
      { key: 'sport', label: 'Sport', type: 'text' },
      // Parents / tuteur
      { key: 'fatherName', label: 'Nom du père', type: 'text' },
      { key: 'fatherJob', label: 'Profession du père', type: 'text' },
      { key: 'motherName', label: 'Nom de la mère', type: 'text' },
      { key: 'motherJob', label: 'Profession de la mère', type: 'text' },
      { key: 'guardianName', label: 'Nom PPCB (personne à contacter)', type: 'text' },
      { key: 'guardianPhone', label: 'Tél. PPCB', type: 'text' },
      { key: 'familySituation', label: 'Situation familiale', type: 'text' },
      { key: 'physicalCondition', label: 'Condition physique', type: 'text' },
      // Frais (XOF)
      { key: 'feeInscription', label: "Frais d'inscription", type: 'money' },
      { key: 'feeApe', label: 'Frais APE', type: 'money' },
      { key: 'feeUniform', label: 'Frais tenue', type: 'money' },
      { key: 'feeTranche1', label: 'Tranche 1 scolarité', type: 'money' },
      { key: 'feeTranche2', label: 'Tranche 2 scolarité', type: 'money' },
      { key: 'feeTranche3', label: 'Tranche 3 scolarité', type: 'money' },
      { key: 'feeCard', label: 'Frais carte scolaire', type: 'money' },
      // Médical
      { key: 'bloodGroup', label: 'Groupe sanguin', type: 'select', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'] },
      { key: 'electrophoresis', label: 'Électrophorèse', type: 'select', options: ['AA', 'AS', 'SS', 'AC', 'SC', 'CC'] },
    ],
  },
  lessonBooks: simple('lessonBooks', 'Cahier de texte', 'lessonStatus', 'Statut du cours', ['Planifié', 'Réalisé', 'Partiel', 'Reporté', 'Annulé']),
  feeSchedules: simple('feeSchedules', 'Échéanciers & relances', 'reminderStatus', 'Statut de relance', ['À envoyer', 'Envoyé', 'Relance 1', 'Relance 2', 'Réglé', 'En retard']),
  scholarships: simple('scholarships', 'Remises, bourses & exonérations', 'aidType', "Type d'aide", ['Remise', 'Bourse', 'Exonération', 'Réduction exceptionnelle']),
  hrContracts: simple('hrContracts', 'Contrats, congés & présences', 'hrType', 'Type RH', ['Contrat', 'Affectation', 'Présence personnel', 'Congé', 'Absence', 'CNSS']),
  stocks: simple('stocks', 'Stocks & fournitures', 'stockType', 'Type de mouvement', ['Entrée', 'Sortie', 'Inventaire', 'Stock critique', 'Affectation', 'Commande']),

  // ── Vie scolaire ──────────────────────────────────────────
  schoolLife: {
    key: 'schoolLife',
    title: 'Vie scolaire',
    labelField: 'studentName',
    dateField: 'eventDate',
    columns: ['studentName', 'classId', 'eventDate', 'eventType', 'sanction', 'behaviorScore'],
    fields: [
      { key: 'studentName', label: 'Élève', type: 'ref', ref: 'students', required: true },
      { key: 'classId', label: 'Classe', type: 'ref', ref: 'classes' },
      { key: 'eventDate', label: 'Date', type: 'date', required: true },
      { key: 'eventType', label: 'Type', type: 'select', options: ['Discipline', 'Présence', 'Sanction', 'Conseil de discipline', 'Comportement'], required: true },
      { key: 'description', label: 'Description', type: 'textarea' },
      { key: 'presenceStatus', label: 'Présence', type: 'select', options: ['Présent', 'Absent', 'Retard', 'Exclu'] },
      { key: 'sanction', label: 'Sanction', type: 'text' },
      { key: 'disciplineCouncilDate', label: 'Conseil de discipline', type: 'date' },
      { key: 'behaviorScore', label: 'Note de comportement', type: 'number' },
      { key: 'decision', label: 'Décision / suivi', type: 'textarea' },
      { key: 'responsible', label: 'Responsable du suivi', type: 'text' },
    ],
  },

  health: {
    key: 'health',
    title: 'Santé & infirmerie',
    labelField: 'studentName',
    dateField: 'reportDate',
    columns: ['studentName', 'classId', 'reportedDisease', 'reportDate', 'followUpStatus'],
    fields: [
      { key: 'studentName', label: 'Élève', type: 'ref', ref: 'students', required: true },
      { key: 'classId', label: 'Classe', type: 'ref', ref: 'classes' },
      { key: 'reportedDisease', label: 'Maladie / pathologie', type: 'text', required: true },
      { key: 'symptoms', label: 'Symptômes', type: 'textarea' },
      { key: 'careGiven', label: 'Soins administrés', type: 'textarea' },
      { key: 'medicineUsed', label: 'Produit pharmacie utilisé', type: 'text' },
      { key: 'quantityUsed', label: 'Quantité utilisée', type: 'number' },
      { key: 'reportDate', label: 'Date de signalement', type: 'date', required: true },
      { key: 'evolution', label: 'Évolution', type: 'textarea' },
      { key: 'followUpStatus', label: 'Statut de suivi', type: 'select', options: ['Sous observation', 'Guéri', 'Orienté', 'À surveiller'] },
      { key: 'referredTo', label: 'Référence / évacuation', type: 'text' },
      { key: 'responsibleContact', label: 'Contact responsable', type: 'text' },
    ],
  },

  adminForms: {
    key: 'adminForms',
    title: 'Formulaires administratifs',
    labelField: 'studentName',
    dateField: 'requestDate',
    columns: ['formType', 'studentName', 'classId', 'requestDate', 'status'],
    fields: [
      { key: 'formType', label: 'Type de formulaire', type: 'select', required: true, options: ["Autorisation d'absence", 'Certificat de scolarité', 'Certificat de niveau', 'Certificat de non redevance', 'Convocation de parents', 'Attestation de présence', 'Relevé de notes', 'Billet retard / absence'] },
      { key: 'studentName', label: 'Élève', type: 'ref', ref: 'students' },
      { key: 'classId', label: 'Classe', type: 'ref', ref: 'classes' },
      { key: 'requestDate', label: 'Date de demande', type: 'date', required: true },
      { key: 'reason', label: 'Motif', type: 'textarea' },
      { key: 'parentName', label: 'Parent / tuteur', type: 'text' },
      { key: 'parentContact', label: 'Contact parent', type: 'text' },
      { key: 'startDate', label: 'Date début', type: 'date' },
      { key: 'endDate', label: 'Date fin', type: 'date' },
      { key: 'totalDays', label: 'Total jours', type: 'number' },
      { key: 'recipient', label: 'Destinataire', type: 'text' },
      { key: 'issuePlace', label: "Lieu d'établissement", type: 'text' },
      { key: 'validityNote', label: 'Mention / validité', type: 'textarea' },
      { key: 'status', label: 'Statut', type: 'select', options: ['Brouillon', 'Préparé', 'Signé', 'Remis', 'Archivé'] },
      { key: 'issuedBy', label: 'Établi par', type: 'text' },
      { key: 'observations', label: 'Observations', type: 'textarea' },
    ],
  },

  // ── Administration établissement ──────────────────────────
  employerRegister: {
    key: 'employerRegister',
    title: 'Registre employeur',
    labelField: 'fullName',
    dateField: 'entryDate',
    columns: ['matricule', 'fullName', 'entryDate', 'originProvinceRegion', 'cnssNumber', 'exitDate'],
    fields: [
      { key: 'matricule', label: 'Matricule', type: 'text', required: true },
      { key: 'entryDate', label: "Date d'entrée", type: 'date', required: true },
      { key: 'fullName', label: 'Nom & prénoms', type: 'text', required: true },
      { key: 'birthDate', label: 'Date de naissance', type: 'date' },
      { key: 'originProvinceRegion', label: "Province & région d'origine", type: 'text' },
      { key: 'cnibNumber', label: 'N° CNIB', type: 'text' },
      { key: 'nationality', label: 'Nationalité', type: 'text' },
      { key: 'cnssNumber', label: 'N° CNSS', type: 'text' },
      { key: 'exitDate', label: 'Date de sortie', type: 'date' },
    ],
  },

  documentTemplates: {
    key: 'documentTemplates',
    title: 'Modèles de documents',
    labelField: 'templateTitle',
    dateField: 'effectiveDate',
    columns: ['templateTitle', 'templateType', 'audience', 'version', 'status'],
    fields: [
      { key: 'templateTitle', label: 'Titre du modèle', type: 'text', required: true },
      { key: 'templateType', label: 'Type de modèle', type: 'select', required: true, options: ['Billet retard / absence', 'Autorisation de sortie', 'Règlement / code', 'Contrat objectif', 'Certificat', 'Reçu', 'Convocation', 'Bulletin', 'Livret', 'SMS/Email', 'Autre'] },
      { key: 'audience', label: 'Public cible', type: 'select', options: ['Élèves', 'Parents', 'Personnel', 'Direction', 'Tous'] },
      { key: 'schoolLevel', label: 'Niveau concerné', type: 'text' },
      { key: 'editableCanvas', label: 'Canevas éditable', type: 'textarea', required: true },
      { key: 'mergeFields', label: 'Variables à fusionner', type: 'textarea' },
      { key: 'ownerRole', label: 'Responsable validation', type: 'select', options: ['Direction', 'Directeur Général', 'Proviseur', 'Censeur', 'Surveillant général', 'Ressources humaines', 'Directeur pédagogique', 'Secrétariat'] },
      { key: 'version', label: 'Version', type: 'text' },
      { key: 'effectiveDate', label: "Date d'application", type: 'date' },
      { key: 'status', label: 'Statut', type: 'select', options: ['Brouillon', 'Actif', 'À réviser', 'Archivé'] },
      { key: 'printNotes', label: 'Instructions impression / PDF', type: 'textarea' },
      { key: 'notes', label: 'Notes de mise à jour', type: 'textarea' },
    ],
  },

  // ── Commerce ──────────────────────────────────────────────
  suppliers: {
    key: 'suppliers',
    title: 'Fournisseurs',
    labelField: 'supplierName',
    dateField: 'lastOrderDate',
    columns: ['supplierName', 'supplierType', 'serviceCategory', 'contractStatus', 'amountDue'],
    fields: [
      { key: 'supplierName', label: 'Nom du fournisseur', type: 'text', required: true },
      { key: 'supplierType', label: 'Type', type: 'select', options: ['Entreprise', 'Association', 'Indépendant', 'Administration', 'Partenaire', 'Autre'] },
      { key: 'contactPerson', label: 'Responsable', type: 'text' },
      { key: 'phone', label: 'Téléphone', type: 'text' },
      { key: 'whatsapp', label: 'WhatsApp', type: 'text' },
      { key: 'email', label: 'E-mail', type: 'text' },
      { key: 'ifuNumber', label: 'IFU', type: 'text' },
      { key: 'address', label: 'Adresse', type: 'textarea' },
      { key: 'serviceCategory', label: 'Catégorie de prestation', type: 'select', options: ['Fournitures scolaires', 'Manuels et livres', 'Tenues scolaires', 'Restauration', 'Transport', 'Maintenance', 'Équipements', 'Pharmacie', 'Services divers'] },
      { key: 'contractStatus', label: 'Statut du contrat', type: 'select', options: ['Actif', 'En évaluation', 'Suspendu', 'Archivé'] },
      { key: 'lastOrderDate', label: 'Dernière commande', type: 'date' },
      { key: 'amountDue', label: 'Solde fournisseur (XOF)', type: 'money' },
      { key: 'notes', label: 'Notes', type: 'textarea' },
    ],
  },

  transfers: {
    key: 'transfers',
    title: 'Transferts inter-établissements',
    labelField: 'studentFullName',
    dateField: 'requestDate',
    columns: ['studentFullName', 'requestDirection', 'requestingSchool', 'requestDate', 'status', 'billingStatus'],
    fields: [
      { key: 'requestDirection', label: 'Type de demande', type: 'select', required: true, options: ['Demande reçue', 'Demande envoyée'] },
      { key: 'requestingSchool', label: 'Établissement demandeur', type: 'text', required: true },
      { key: 'holdingSchool', label: 'Établissement détenteur', type: 'text' },
      { key: 'studentFullName', label: 'Élève', type: 'text', required: true },
      { key: 'studentMatricule', label: 'Matricule élève', type: 'text' },
      { key: 'birthDate', label: 'Date de naissance', type: 'date' },
      { key: 'sourceClass', label: "Classe d'origine", type: 'text' },
      { key: 'targetClass', label: 'Classe de destination', type: 'text' },
      { key: 'requestedDataScope', label: 'Données demandées', type: 'select', options: ['Dossier complet', 'Dossier administratif', 'Notes et historique scolaire', 'Situation financière', 'Discipline et assiduité', 'Dossier médical minimal'] },
      { key: 'requestDate', label: 'Date de demande', type: 'date', required: true },
      { key: 'status', label: 'Statut', type: 'select', options: ['En attente', 'Validée', 'Rejetée', 'Annulée'] },
      { key: 'decisionDate', label: 'Date de décision', type: 'date' },
      { key: 'rejectionReason', label: 'Motif de rejet', type: 'select', options: ['Dossier incomplet', 'Frais impayés', 'Litige en cours', 'Établissement non reconnu', 'Autre'] },
      { key: 'rejectionDetails', label: 'Précision rejet', type: 'textarea' },
      { key: 'approvedBy', label: 'Validé par', type: 'text' },
      { key: 'transferFee', label: 'Frais de transfert (XOF)', type: 'money' },
      { key: 'billingStatus', label: 'Statut facturation', type: 'select', options: ['À payer', 'Payé', 'En retard', 'Annulé'] },
      { key: 'auditNotes', label: 'Journal / observations', type: 'textarea' },
    ],
  },
};
